























































































































import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
  name: "AdminData"
})
export default class AdminData extends Vue {
  @Prop()
  readonly value!: {};

  @Prop({ default: false })
  readonly unfold!: boolean;

  public showHco = false;
  public showHcp = false;

  mounted() {
    if (this.unfold) {
      this.showHco = true;
      this.showHcp = true;
    }
  }
}
